import React, { Component, PropTypes } from 'react'
import { message, Modal, Spin } from 'antd'
import { ARRAY_PGT_FILE_TYPE } from 'app/utils/const'
import './index.scss'

export default class HaplotypeCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      file: {},
      uploadModalShowed: false
    }
  }

  onUpload = (e) => {
    const file = e.currentTarget.files[0]
    this.setState({ file })
  }

  onConfirmSubmit = () => {
    const { store: { uploadFile }, reportId, dir, cb } = this.props
    const { file } = this.state
    if (!file.name) return message.warn('请选择文件')
    if (!ARRAY_PGT_FILE_TYPE.includes(file.name)) {
      return message.warn('请上传正确的文件')
    }
    this.setState({
      uploadModalShowed: true
    })
    uploadFile(reportId, file, dir)
      .then(res => {
        this.setState({ file: {} })
        this.setState({
          uploadModalShowed: false
        })
        cb()
      })
      .catch(err => {
        message.error(err.message)
        this.setState({
          uploadModalShowed: false
        })
      })
  }

  render() {
    const { file } = this.state
    const { title, children, path } = this.props
    return (
      <div className='haplotype-card'>
        <div className="card-title">
          <div className="title-indicator"></div>
          {path && (
            <div className='title-wrapper'>
              <div className="title">
                <a href={path}>{title}</a>
              </div>
              <div className='upload-wrapper'>
                <input
                  id={`upload-${title}`}
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => this.onUpload(e)}
                />
                <label
                  htmlFor={`upload-${title}`}
                  className="upload-label"
                >
                  请选择文件
                </label>
                <span className='file-name'>
                  {file.name ? file.name : ' 未选择任何文件'}
                </span>
                <span
                  className="confirm-btn"
                  type='primary'
                  size="small"
                  onClick={this.onConfirmSubmit}
                >
                  确认上传
                </span>
              </div>
            </div>
          )}
          {!path && (
            <div className="title">
              {title}
            </div>
          )}
        </div>
        <div className='card-body'>
          {children}
        </div>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.uploadModalShowed}
          footer={null}
        >
          <div className='export-loading'>
            <Spin size='large' />
          </div>
          <div className="export-tips">正在上传中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }
}

HaplotypeCard.propTypes = {
  title: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/app/components/normal/HaplotypeCard/index.js